/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as _authenticatedRouteImport } from './routes/__authenticated'
import { Route as _authenticatedTimeOffsRouteRouteImport } from './routes/__authenticated/time-offs/route'
import { Route as _authenticatedExpensesRouteRouteImport } from './routes/__authenticated/expenses/route'
import { Route as _authenticatedApprovalsRouteRouteImport } from './routes/__authenticated/approvals/route'
import { Route as _authenticatedTimesheetIndexRouteImport } from './routes/__authenticated/timesheet/index'
import { Route as _authenticatedTimeOffsIndexRouteImport } from './routes/__authenticated/time-offs/index'
import { Route as _authenticatedExpensesIndexRouteImport } from './routes/__authenticated/expenses/index'
import { Route as _authenticatedDashboardIndexRouteImport } from './routes/__authenticated/dashboard/index'
import { Route as _authenticatedApprovalsIndexRouteImport } from './routes/__authenticated/approvals/index'
import { Route as _authenticatedApprovalsRequiredAttentionRouteImport } from './routes/__authenticated/approvals/required-attention'
import { Route as _authenticatedApprovalsPendingRouteImport } from './routes/__authenticated/approvals/pending'
import { Route as _authenticatedApprovalsHistoryRouteImport } from './routes/__authenticated/approvals/history'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const _authenticatedRoute = _authenticatedRouteImport.update({
  id: '/__authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const _authenticatedTimeOffsRouteRoute =
  _authenticatedTimeOffsRouteRouteImport.update({
    id: '/time-offs',
    path: '/time-offs',
    getParentRoute: () => _authenticatedRoute,
  } as any)
const _authenticatedExpensesRouteRoute =
  _authenticatedExpensesRouteRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => _authenticatedRoute,
  } as any)
const _authenticatedApprovalsRouteRoute =
  _authenticatedApprovalsRouteRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => _authenticatedRoute,
  } as any)
const _authenticatedTimesheetIndexRoute =
  _authenticatedTimesheetIndexRouteImport.update({
    id: '/timesheet/',
    path: '/timesheet/',
    getParentRoute: () => _authenticatedRoute,
  } as any)
const _authenticatedTimeOffsIndexRoute =
  _authenticatedTimeOffsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authenticatedTimeOffsRouteRoute,
  } as any)
const _authenticatedExpensesIndexRoute =
  _authenticatedExpensesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authenticatedExpensesRouteRoute,
  } as any)
const _authenticatedDashboardIndexRoute =
  _authenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => _authenticatedRoute,
  } as any)
const _authenticatedApprovalsIndexRoute =
  _authenticatedApprovalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => _authenticatedApprovalsRouteRoute,
  } as any)
const _authenticatedApprovalsRequiredAttentionRoute =
  _authenticatedApprovalsRequiredAttentionRouteImport.update({
    id: '/required-attention',
    path: '/required-attention',
    getParentRoute: () => _authenticatedApprovalsRouteRoute,
  } as any)
const _authenticatedApprovalsPendingRoute =
  _authenticatedApprovalsPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => _authenticatedApprovalsRouteRoute,
  } as any)
const _authenticatedApprovalsHistoryRoute =
  _authenticatedApprovalsHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => _authenticatedApprovalsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/sign-in': typeof SignInRoute
  '/approvals': typeof _authenticatedApprovalsRouteRouteWithChildren
  '/expenses': typeof _authenticatedExpensesRouteRouteWithChildren
  '/time-offs': typeof _authenticatedTimeOffsRouteRouteWithChildren
  '/approvals/history': typeof _authenticatedApprovalsHistoryRoute
  '/approvals/pending': typeof _authenticatedApprovalsPendingRoute
  '/approvals/required-attention': typeof _authenticatedApprovalsRequiredAttentionRoute
  '/approvals/': typeof _authenticatedApprovalsIndexRoute
  '/dashboard': typeof _authenticatedDashboardIndexRoute
  '/expenses/': typeof _authenticatedExpensesIndexRoute
  '/time-offs/': typeof _authenticatedTimeOffsIndexRoute
  '/timesheet': typeof _authenticatedTimesheetIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/approvals/history': typeof _authenticatedApprovalsHistoryRoute
  '/approvals/pending': typeof _authenticatedApprovalsPendingRoute
  '/approvals/required-attention': typeof _authenticatedApprovalsRequiredAttentionRoute
  '/approvals': typeof _authenticatedApprovalsIndexRoute
  '/dashboard': typeof _authenticatedDashboardIndexRoute
  '/expenses': typeof _authenticatedExpensesIndexRoute
  '/time-offs': typeof _authenticatedTimeOffsIndexRoute
  '/timesheet': typeof _authenticatedTimesheetIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/__authenticated': typeof _authenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/__authenticated/approvals': typeof _authenticatedApprovalsRouteRouteWithChildren
  '/__authenticated/expenses': typeof _authenticatedExpensesRouteRouteWithChildren
  '/__authenticated/time-offs': typeof _authenticatedTimeOffsRouteRouteWithChildren
  '/__authenticated/approvals/history': typeof _authenticatedApprovalsHistoryRoute
  '/__authenticated/approvals/pending': typeof _authenticatedApprovalsPendingRoute
  '/__authenticated/approvals/required-attention': typeof _authenticatedApprovalsRequiredAttentionRoute
  '/__authenticated/approvals/': typeof _authenticatedApprovalsIndexRoute
  '/__authenticated/dashboard/': typeof _authenticatedDashboardIndexRoute
  '/__authenticated/expenses/': typeof _authenticatedExpensesIndexRoute
  '/__authenticated/time-offs/': typeof _authenticatedTimeOffsIndexRoute
  '/__authenticated/timesheet/': typeof _authenticatedTimesheetIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/sign-in'
    | '/approvals'
    | '/expenses'
    | '/time-offs'
    | '/approvals/history'
    | '/approvals/pending'
    | '/approvals/required-attention'
    | '/approvals/'
    | '/dashboard'
    | '/expenses/'
    | '/time-offs/'
    | '/timesheet'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/approvals/history'
    | '/approvals/pending'
    | '/approvals/required-attention'
    | '/approvals'
    | '/dashboard'
    | '/expenses'
    | '/time-offs'
    | '/timesheet'
  id:
    | '__root__'
    | '/__authenticated'
    | '/sign-in'
    | '/__authenticated/approvals'
    | '/__authenticated/expenses'
    | '/__authenticated/time-offs'
    | '/__authenticated/approvals/history'
    | '/__authenticated/approvals/pending'
    | '/__authenticated/approvals/required-attention'
    | '/__authenticated/approvals/'
    | '/__authenticated/dashboard/'
    | '/__authenticated/expenses/'
    | '/__authenticated/time-offs/'
    | '/__authenticated/timesheet/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  _authenticatedRoute: typeof _authenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__authenticated': {
      id: '/__authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof _authenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/__authenticated/time-offs': {
      id: '/__authenticated/time-offs'
      path: '/time-offs'
      fullPath: '/time-offs'
      preLoaderRoute: typeof _authenticatedTimeOffsRouteRouteImport
      parentRoute: typeof _authenticatedRoute
    }
    '/__authenticated/expenses': {
      id: '/__authenticated/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof _authenticatedExpensesRouteRouteImport
      parentRoute: typeof _authenticatedRoute
    }
    '/__authenticated/approvals': {
      id: '/__authenticated/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof _authenticatedApprovalsRouteRouteImport
      parentRoute: typeof _authenticatedRoute
    }
    '/__authenticated/timesheet/': {
      id: '/__authenticated/timesheet/'
      path: '/timesheet'
      fullPath: '/timesheet'
      preLoaderRoute: typeof _authenticatedTimesheetIndexRouteImport
      parentRoute: typeof _authenticatedRoute
    }
    '/__authenticated/time-offs/': {
      id: '/__authenticated/time-offs/'
      path: '/'
      fullPath: '/time-offs/'
      preLoaderRoute: typeof _authenticatedTimeOffsIndexRouteImport
      parentRoute: typeof _authenticatedTimeOffsRouteRoute
    }
    '/__authenticated/expenses/': {
      id: '/__authenticated/expenses/'
      path: '/'
      fullPath: '/expenses/'
      preLoaderRoute: typeof _authenticatedExpensesIndexRouteImport
      parentRoute: typeof _authenticatedExpensesRouteRoute
    }
    '/__authenticated/dashboard/': {
      id: '/__authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof _authenticatedDashboardIndexRouteImport
      parentRoute: typeof _authenticatedRoute
    }
    '/__authenticated/approvals/': {
      id: '/__authenticated/approvals/'
      path: '/'
      fullPath: '/approvals/'
      preLoaderRoute: typeof _authenticatedApprovalsIndexRouteImport
      parentRoute: typeof _authenticatedApprovalsRouteRoute
    }
    '/__authenticated/approvals/required-attention': {
      id: '/__authenticated/approvals/required-attention'
      path: '/required-attention'
      fullPath: '/approvals/required-attention'
      preLoaderRoute: typeof _authenticatedApprovalsRequiredAttentionRouteImport
      parentRoute: typeof _authenticatedApprovalsRouteRoute
    }
    '/__authenticated/approvals/pending': {
      id: '/__authenticated/approvals/pending'
      path: '/pending'
      fullPath: '/approvals/pending'
      preLoaderRoute: typeof _authenticatedApprovalsPendingRouteImport
      parentRoute: typeof _authenticatedApprovalsRouteRoute
    }
    '/__authenticated/approvals/history': {
      id: '/__authenticated/approvals/history'
      path: '/history'
      fullPath: '/approvals/history'
      preLoaderRoute: typeof _authenticatedApprovalsHistoryRouteImport
      parentRoute: typeof _authenticatedApprovalsRouteRoute
    }
  }
}

interface _authenticatedApprovalsRouteRouteChildren {
  _authenticatedApprovalsHistoryRoute: typeof _authenticatedApprovalsHistoryRoute
  _authenticatedApprovalsPendingRoute: typeof _authenticatedApprovalsPendingRoute
  _authenticatedApprovalsRequiredAttentionRoute: typeof _authenticatedApprovalsRequiredAttentionRoute
  _authenticatedApprovalsIndexRoute: typeof _authenticatedApprovalsIndexRoute
}

const _authenticatedApprovalsRouteRouteChildren: _authenticatedApprovalsRouteRouteChildren =
  {
    _authenticatedApprovalsHistoryRoute: _authenticatedApprovalsHistoryRoute,
    _authenticatedApprovalsPendingRoute: _authenticatedApprovalsPendingRoute,
    _authenticatedApprovalsRequiredAttentionRoute:
      _authenticatedApprovalsRequiredAttentionRoute,
    _authenticatedApprovalsIndexRoute: _authenticatedApprovalsIndexRoute,
  }

const _authenticatedApprovalsRouteRouteWithChildren =
  _authenticatedApprovalsRouteRoute._addFileChildren(
    _authenticatedApprovalsRouteRouteChildren,
  )

interface _authenticatedExpensesRouteRouteChildren {
  _authenticatedExpensesIndexRoute: typeof _authenticatedExpensesIndexRoute
}

const _authenticatedExpensesRouteRouteChildren: _authenticatedExpensesRouteRouteChildren =
  {
    _authenticatedExpensesIndexRoute: _authenticatedExpensesIndexRoute,
  }

const _authenticatedExpensesRouteRouteWithChildren =
  _authenticatedExpensesRouteRoute._addFileChildren(
    _authenticatedExpensesRouteRouteChildren,
  )

interface _authenticatedTimeOffsRouteRouteChildren {
  _authenticatedTimeOffsIndexRoute: typeof _authenticatedTimeOffsIndexRoute
}

const _authenticatedTimeOffsRouteRouteChildren: _authenticatedTimeOffsRouteRouteChildren =
  {
    _authenticatedTimeOffsIndexRoute: _authenticatedTimeOffsIndexRoute,
  }

const _authenticatedTimeOffsRouteRouteWithChildren =
  _authenticatedTimeOffsRouteRoute._addFileChildren(
    _authenticatedTimeOffsRouteRouteChildren,
  )

interface _authenticatedRouteChildren {
  _authenticatedApprovalsRouteRoute: typeof _authenticatedApprovalsRouteRouteWithChildren
  _authenticatedExpensesRouteRoute: typeof _authenticatedExpensesRouteRouteWithChildren
  _authenticatedTimeOffsRouteRoute: typeof _authenticatedTimeOffsRouteRouteWithChildren
  _authenticatedDashboardIndexRoute: typeof _authenticatedDashboardIndexRoute
  _authenticatedTimesheetIndexRoute: typeof _authenticatedTimesheetIndexRoute
}

const _authenticatedRouteChildren: _authenticatedRouteChildren = {
  _authenticatedApprovalsRouteRoute:
    _authenticatedApprovalsRouteRouteWithChildren,
  _authenticatedExpensesRouteRoute:
    _authenticatedExpensesRouteRouteWithChildren,
  _authenticatedTimeOffsRouteRoute:
    _authenticatedTimeOffsRouteRouteWithChildren,
  _authenticatedDashboardIndexRoute: _authenticatedDashboardIndexRoute,
  _authenticatedTimesheetIndexRoute: _authenticatedTimesheetIndexRoute,
}

const _authenticatedRouteWithChildren = _authenticatedRoute._addFileChildren(
  _authenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  _authenticatedRoute: _authenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
